export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toISOString().split('T')[0];
}

export function formatDateTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString();
}

export function getCurrentMonth(): { start: string; end: string } {
  const now = new Date();
  const start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  const end = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 0, 23, 59, 59));

  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
}

export function getMonthRange(year: number, month: number): { start: string; end: string } {
  const start = new Date(Date.UTC(year, month - 1, 1));
  const end = new Date(Date.UTC(year, month, 0, 23, 59, 59));

  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
}

export function getMonthTimestamps(year: number, month: number): { startTimestamp: number; endTimestamp: number } {
  const startTimestamp = Date.UTC(year, month - 1, 1) / 1000;
  const endTimestamp = Date.UTC(year, month, 1) / 1000;
  return { startTimestamp, endTimestamp };
}

export function shouldResetCard(lastResetDate: string): boolean {
  const lastReset = new Date(lastResetDate);
  const now = new Date();

  if (now.getMonth() !== lastReset.getMonth() || now.getFullYear() !== lastReset.getFullYear()) {
    return now.getDate() >= 1;
  }

  return false;
}

export function getFirstDayOfCurrentMonth(): string {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  return formatDate(firstDay);
}

export function formatCurrency(amount: number, currency: 'USD' | 'MVR' = 'USD'): string {
  return `${currency} ${amount.toFixed(2)}`;
}

export function getMonthName(month: number): string {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  return months[month - 1];
}
